import { Component, Prop, Vue} from "vue-property-decorator";
import { Product, UiState, ConfiguratorValueUpdateModel, configuratorConstants, StepByStepInstructionsProductListModuleModel } from "../models";
import { productConfiguratorStore as store } from "./../store";
import HtmlElementHelper from "@/services/HtmlElementHelper";
import ProductSpecification from "./ProductSpecification";
import cart from "../../../services/Cart";
import GoogleEnhancedEcommerce from "../../../services/GoogleEnhancedEcommerce";
import "whatwg-fetch";
import { AddToCartContainer } from "@/components";
import CarbonSavingsCalculation from "../../../components/ProductPage/CarbonSavingsCalculation";

@Component({
    components: {
        ProductSpecification,
        AddToCartContainer,
        CarbonSavingsCalculation
  }
})
export default class StepByStepInstructionsProductListModule extends Vue {
    @Prop()
    protected vm!: StepByStepInstructionsProductListModuleModel;
    protected productStates: Array<UiState<boolean>> = [];
    protected carbonSavingsProductStates: Array<UiState<boolean>> = [];
    protected productsInCookie: string[] = [];
    protected readonly googleAnalyticsDimensionIdentifier: string = "ProductConfiguratorPage";

    protected created() {
        this.vm.products.forEach(p => this.productStates.push({ id: p.articleNumber} as UiState<boolean>));
        this.vm.products.forEach(p => this.carbonSavingsProductStates.push({ id: p.articleNumber} as UiState<boolean>));
    }

    protected mounted() {
        const element = document.getElementById("hdnCheckCartItems") as HTMLInputElement;
        if (element) {
            const elementVal = element.value;
            if (elementVal) {
                fetch(elementVal as string).then(response => {
                    response.json().then(jsondata => {
                            this.vm.products.filter(x => jsondata.indexOf(x.articleNumber) > -1).map(y => {
                            store.stepByStepInstructionsAddProduct(y);
                        });
                    });
                });
            }
        }
    }

    protected toggleProductSpecification(product: Product) {
        const productStateIndex = this.productStates.findIndex(s => s.id === product.articleNumber);
        if (productStateIndex !== -1) {
            const productState = this.productStates[productStateIndex];
            productState.state = !productState.state;
            this.productStates.splice(productStateIndex, 1, productState);
        }
    }

    protected showProductSpecification(product: Product): boolean {
        const productState = this.productStates.find(s => s.id === product.articleNumber);
        if (productState) {
            return productState.state;
        }
        return false;
    }

    protected addProduct(product: Product) {
        cart.addToCart({
            quantity: 1,
            variantId: product.articleNumber,
            variantSystemId: "",
        });

        const gee = new GoogleEnhancedEcommerce();
        gee.PushAddToCartToGoogle(
            product.name,
            product.articleNumber,
            product.productPrice ? product.productPrice.price : 0,
            "",
            1,
            this.googleAnalyticsDimensionIdentifier,
            product.productPrice ? product.productPrice.currencyCode : "",
            window.site.settings.activateProductWebshop ? true : false,
        );

        store.stepByStepInstructionsAddProduct(product);
    }

    protected removeProduct(product: Product) {
        cart.removeFromCart({
            quantity: -1,
            variantId: product.articleNumber,
            variantSystemId: "",
        });

        store.stepByStepInstructionsRemoveProduct(product);
    }

    protected isProductAdded(product: Product): boolean {
        return store.stepByStepInstructionsProducts.some(x => x.articleNumber === product.articleNumber);
    }

    protected getButtonText(product: Product): string {
        if (this.isProductAdded(product)) {
            return this.translations.addedProductButtonText;
        }
        return this.translations.addToCartButtonText;
    }

    protected handleQuantityUpdate(event: Event, product: Product) {
        if (event.target instanceof HTMLInputElement && !HtmlElementHelper.isValidNumberInput(event.target)) {
            product.confirmedQuantity = Number(event.target.min);
        }

        if (product.confirmedQuantity === 0) {
            this.removeProduct(product);
        }
    }

    protected getCarbonSavingsProductState(product: Product) {
        return this.carbonSavingsProductStates.find(ps => ps.id === product.articleNumber);
    }

    protected toggleCarbonSavingsInfo(product: Product) {
        const productStateIndex = this.carbonSavingsProductStates.findIndex(s => s.id === product.articleNumber);
        if (productStateIndex !== -1) {
            const productState = this.carbonSavingsProductStates[productStateIndex];
            productState.state = !productState.state;
            this.carbonSavingsProductStates.splice(productStateIndex, 1, productState);
        }
    }

    protected showCarbonSavingsInfo(product: Product): boolean {
        const productState = this.getCarbonSavingsProductState(product);
        if (productState) {
            return productState.state;
        }
        return false;
    }

    get translations() {
        return store.translations;
    }
}
